import { render } from "./StatisticsBrowser.vue?vue&type=template&id=bea2d6ee&scoped=true"
import script from "./StatisticsBrowser.vue?vue&type=script&lang=js"
export * from "./StatisticsBrowser.vue?vue&type=script&lang=js"

import "./StatisticsBrowser.vue?vue&type=style&index=0&id=bea2d6ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea2d6ee"]])

export default __exports__